import { AppState } from '@/store';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const PRODUCTS_PER_PAGE = 10;

const usePaginatedProducts = () => {
  const { filteredProducts, pageDesign } = useSelector((state: AppState) => state.partner);
  const [page, setPage] = useState(1);
  const [shownProducts, setShownProducts] = useState([]);

  useEffect(() => {
    const isItemTypeSort = pageDesign?.flags.itemTypeSortOrder ? true : false;

    if (filteredProducts && filteredProducts.length > 0) {
      const sortedFilteredProducts = filteredProducts?.sort((a, b) => {
        if (isItemTypeSort) {
          return a.typeSortOrder - b.typeSortOrder;
        }

        return a.sortOrder - b.sortOrder;
      });

      setShownProducts(
        sortedFilteredProducts.length > PRODUCTS_PER_PAGE
          ? sortedFilteredProducts.slice(0, PRODUCTS_PER_PAGE)
          : sortedFilteredProducts
      );
      setPage(1);
    }
  }, [filteredProducts, pageDesign]);

  const onPageChangeHandler = (newPage) => {
    setPage(newPage);
    const start = (newPage - 1) * PRODUCTS_PER_PAGE;
    setShownProducts(filteredProducts.slice(start, start + PRODUCTS_PER_PAGE));
    const productsListOffset =
      window.pageYOffset + document.getElementById('productsListHeader').getBoundingClientRect().top || 130;
    window.scrollTo(0, productsListOffset - 130);
  };

  return {
    onPageChangeHandler,
    products: shownProducts,
    productsCount: filteredProducts.length ?? 0,
    page,
    pages: Math.ceil(filteredProducts.length / PRODUCTS_PER_PAGE),
    shouldShowPagination: filteredProducts.length > PRODUCTS_PER_PAGE,
  };
};

export default usePaginatedProducts;
